import { atom } from 'jotai'

import { type VehicleDispatchBoardPartnerCustomKeyExEntity } from '@/libs/api'

import type {
  DetailInfo,
  PartnerInfo,
  SubPartnerInfo,
  TruckInfo
} from '../../formatters'

/**
 * パートナーユーザー向けの矢羽根の表示モーダル（閲覧専用）に出す対象（#5600）。
 * 矢羽根の内容は配車板の応答（DetailInfo）から描き、追加の API は叩かない。
 * 配車情報（パートナー・車両・実運送会社）は矢羽根が持たない場合に車両行の値で補うため、
 * 開く側が解決した値を添える。パートナーに公開したカスタムキー（#5602）は配車板の応答の
 * 全体に 1 つあるため、開く時点の配車板の応答から写して添える
 */
export type PartnerDispatchDetailViewTarget = {
  detail: DetailInfo
  partner: PartnerInfo | null
  truck: TruckInfo | null
  subPartner: SubPartnerInfo | null
  customKeys: VehicleDispatchBoardPartnerCustomKeyExEntity[]
}

export const partnerDispatchDetailViewAtom =
  atom<PartnerDispatchDetailViewTarget | null>(null)

partnerDispatchDetailViewAtom.debugLabel = 'partnerDispatchDetailViewAtom'
